var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3326 33H24.6651C19.3351 33 14.9976 28.9625 14.9976 24C14.9976 19.0375 19.3351 15 24.6651 15H47.3326C52.6626 15 57.0001 19.0375 57.0001 24C57.0001 28.9625 52.6626 33 47.3326 33ZM24.6651 21C22.6426 21 20.9976 22.345 20.9976 24C20.9976 25.655 22.6426 27 24.6651 27H47.3326C49.3551 27 51.0001 25.655 51.0001 24C51.0001 22.345 49.3551 21 47.3326 21H24.6651Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.665 33.5034L49.3368 38.4957L85.3376 62.4961L88.6657 57.5038L52.665 33.5034Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9226 100.2L33.0626 94.2425L27.0426 100.168L18.9401 92.5125L23.0601 88.15L26.9576 91.8325L33.1276 85.7575L39.0776 91.8L45.0001 86.205L51.0001 91.8725L57.0001 86.205L63.0001 91.8725L69.0001 86.205L75.0001 91.8725L81.0001 86.205L87.0001 91.8725L93.0001 86.205L99.0001 91.8725L102.94 88.15L107.06 92.5125L99.0001 100.128L93.0001 94.4575L87.0001 100.128L81.0001 94.4575L75.0001 100.128L69.0001 94.4575L63.0001 100.128L57.0001 94.4575L51.0001 100.128L45.0001 94.4575L38.9226 100.2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 78H33.0001C33.0001 70.935 28.0651 66 21.0001 66V60C26.0076 60 30.5826 61.8175 33.8826 65.1175C37.1826 68.4175 39.0001 72.9925 39.0001 78Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5053 37.3332L48.5048 46.3339L53.4971 49.6621L59.4976 40.6614L54.5053 37.3332Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5049 43.3329L57.5045 52.3336L62.4968 55.6618L68.4972 46.6611L63.5049 43.3329Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5045 49.3326L66.504 58.3334L71.4963 61.6616L77.4968 52.6608L72.5045 49.3326Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105 84H21.0001V36H27.0001V78H99.0001V72C99.0001 67.0375 94.9626 63 90.0001 63C85.0376 63 81.0001 67.0375 81.0001 72H75.0001C75.0001 63.73 81.7301 57 90.0001 57C98.2701 57 105 63.73 105 72V84Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/Activities.84c7d967.svg";
export { ForwardRef as ReactComponent };